import React from 'react'

import {Props} from './CloudModel'

export default function Cloud(props: Props) {
	const {id, primaryText, secondaryText, arrow} = props
	return (
		<div className='thought' id={id}>
			<div className='cloud1'></div>
			<div className='cloud2'></div>
			<div className='cloud3'></div>
			<div className='cloud4'></div>
			<div className='cloud5'></div>
			<div className='cloud6'></div>
			<div className={arrow}></div>
			<div className='inner'>
				{primaryText} <br /> {secondaryText}
			</div>
		</div>
	)
}
